import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "./pages/Home";
import { AppPage } from "./pages/AppPage";
import { Store } from "./pages/Store";
import { Workout } from "./pages/Workout";
import { LegalPage } from "./pages/legal/LegalPage";
import { documents, type Slug } from "./pages/legal/documents";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/store" element={<Store />} />
        <Route path="/app" element={<AppPage />} />
        <Route path="/workout" element={<Workout />} />
        {/* Two fixed addresses per document rather than one that guesses: a store form wants an
            address that always answers in the language it was filed under. */}
        {(Object.keys(documents) as Slug[]).flatMap((slug) => [
          <Route
            key={slug}
            path={`/app/${slug}`}
            element={<LegalPage slug={slug} language="en" />}
          />,
          <Route
            key={`${slug}-it`}
            path={`/app/${slug}/it`}
            element={<LegalPage slug={slug} language="it" />}
          />,
        ])}
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
